const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 接口文档地址：
// http://219.128.52.2:7788/swagger-ui.html#/payment-controller/paymentHandleTwoUsingPOST
const payment_paymentHandleTwo = (pParameter) => {
    if (!pParameter) pParameter = {};

    // const sample_parameter = {
    //     "companyId": 151,
    //     clubId: 1,
    //     "orderNo": "D315768531420",
    //     "businessContent": "{\"businessType\":2,\"paymentType\":1,\"travelOrderType\":1}",
    //
    //     "subject": "zz",
    //     "paymentChannelVos": [
    //
    //         {
    //             "paymentChannel": 4,
    //             "amount": 200
    //         },
    //         {
    //             "paymentChannel": 6,
    //             "amount": 3000
    //         }
    //     ],
    //     "password": "123456",
    //     toBackUrl: ``,
    // };

    const companyId = pParameter.companyId || ``;
    const clubId = pParameter.clubId || ``;
    const orderNo = pParameter.orderNo || ``;
    const businessContent = pParameter.businessContent || ``;
    const subject = pParameter.subject || ``;
    const paymentChannelVos = pParameter.paymentChannelVos || [];
    const password = pParameter.password || ``;
    const toBackUrl = pParameter.toBackUrl || ``;
    const clientType = pParameter.clientType || 1;//客户端类型：1.b2b，2.b2c，3.差旅,默认为1
    const returnUrl = pParameter.returnUrl || ``;

    const p = {
        method: 'post',
        urlSuffix: '/payment/paymentHandleTwo',
        data: {
            companyId,
            clubId,
            orderNo,
            businessContent,
            subject,
            paymentChannelVos,
            password,
            toBackUrl,
            clientType,
            returnUrl,
        },
    };
    return Q.when()
        .then(function () {
            return __request(p);
        })
        .then(function (data) {
            return Q.resolve(data);
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};
module.exports = payment_paymentHandleTwo;
